import Link from 'next/link'
import useT from "@hooks/useTranslation"
import { ICON_DIMEN } from '@components/search/formLinks'

const FormLink = ({ i, t, to, svg, active, styles, ...rest }) => (
    <Link href={to}>
        <a className={i === active
                ? styles.active_link
                : styles.link} title={t} {...rest}>

            { svg && <img {...ICON_DIMEN}
                src={`/svg/${svg}.svg`}
                alt={t}
            /> }

            { useT(t) }
        </a>
    </Link>
)

export default FormLink